var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-lens-builder" }, [
    _c("div", { staticClass: "viq-lens-builder__header" }, [
      _c("div", { staticClass: "viq-lens-builder__header-left" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
            },
          },
          [
            _c("path", {
              attrs: {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M13 10V3L4 14h7v7l9-11h-7z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("Lens Builder")]),
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "viq-lens-builder__close", on: { click: _vm.close } },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
              },
            },
            [
              _c("path", {
                attrs: {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M6 18L18 6M6 6l12 12",
                },
              }),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "chatArea", staticClass: "viq-lens-builder__chat" },
      [
        _vm.messages.length === 0 && !_vm.loading
          ? _c("div", { staticClass: "viq-lens-builder__welcome" }, [
              _c("p", [_vm._v("Describe the lens you want to create.")]),
              _vm._v(" "),
              _c("p", { staticClass: "viq-lens-builder__welcome-hint" }, [
                _vm._v(
                  "\n        e.g. “I need a lens for tracking Malta gambling regulations”\n      "
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.messages, function (msg, i) {
          return _c(
            "div",
            { key: i, staticClass: "viq-lens-builder__msg-row" },
            [
              msg.role === "user"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "viq-lens-builder__msg viq-lens-builder__msg--user",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "viq-lens-builder__bubble viq-lens-builder__bubble--user",
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(msg.content) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              msg.role === "assistant"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "viq-lens-builder__msg viq-lens-builder__msg--assistant",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "viq-lens-builder__bubble viq-lens-builder__bubble--assistant",
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(msg.content) + "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      msg.config
                        ? _c(
                            "div",
                            { staticClass: "viq-lens-builder__config-card" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "viq-lens-builder__config-header",
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 14 14",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M7 1L9 5.5L14 6.5L10.5 10L11.5 14L7 12L2.5 14L3.5 10L0 6.5L5 5.5L7 1Z",
                                          fill: "currentColor",
                                          opacity: "0.6",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "viq-lens-builder__config-name",
                                      },
                                      [_vm._v(_vm._s(msg.config.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "viq-lens-builder__config-desc",
                                      },
                                      [_vm._v(_vm._s(msg.config.description))]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              msg.config.system_instructions
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "viq-lens-builder__config-section",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "viq-lens-builder__config-label",
                                        },
                                        [_vm._v("Instructions")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "viq-lens-builder__config-text",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              msg.config.system_instructions
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "viq-lens-builder__config-badges",
                                },
                                [
                                  msg.config.output_format &&
                                  msg.config.output_format.style
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "viq-lens-builder__badge viq-lens-builder__badge--style",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.formatOutputStyle(
                                                  msg.config.output_format.style
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  msg.config.output_format &&
                                  msg.config.output_format.length
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "viq-lens-builder__badge viq-lens-builder__badge--length",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                msg.config.output_format.length
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(
                                    (msg.config.default_filters &&
                                      msg.config.default_filters
                                        .content_types) ||
                                      [],
                                    function (ct) {
                                      return _c(
                                        "span",
                                        {
                                          key: "ct-" + ct,
                                          staticClass:
                                            "viq-lens-builder__badge viq-lens-builder__badge--content",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(ct.replace(/_/g, " ")) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    (msg.config.default_filters &&
                                      msg.config.default_filters
                                        .jurisdictions) ||
                                      [],
                                    function (j) {
                                      return _c(
                                        "span",
                                        {
                                          key: "j-" + j,
                                          staticClass:
                                            "viq-lens-builder__badge viq-lens-builder__badge--jurisdiction",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(j) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              msg.config.pinned_content_ids &&
                              msg.config.pinned_content_ids.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "viq-lens-builder__config-pinned",
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            msg.config.pinned_content_ids.length
                                          ) +
                                          " pinned content item" +
                                          _vm._s(
                                            msg.config.pinned_content_ids
                                              .length !== 1
                                              ? "s"
                                              : ""
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              msg.config.intent_tags &&
                              msg.config.intent_tags.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "viq-lens-builder__config-tags",
                                    },
                                    _vm._l(
                                      msg.config.intent_tags,
                                      function (tag) {
                                        return _c(
                                          "span",
                                          {
                                            key: tag,
                                            staticClass:
                                              "viq-lens-builder__tag",
                                          },
                                          [
                                            _vm._v(
                                              "\n              #" +
                                                _vm._s(tag) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          )
        }),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              {
                staticClass:
                  "viq-lens-builder__msg viq-lens-builder__msg--assistant",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "viq-lens-builder__bubble viq-lens-builder__bubble--loading",
                  },
                  [
                    _c("span", { staticClass: "viq-lens-builder__spinner" }),
                    _vm._v(" "),
                    _vm.stage === "analyzing"
                      ? _c("span", [_vm._v("Analysing your request...")])
                      : _vm.stage === "searching"
                      ? _c("span", [_vm._v("Finding relevant content...")])
                      : _vm.stage === "building"
                      ? _c("span", [_vm._v("Building your lens...")])
                      : _vm.stage === "refining"
                      ? _c("span", [_vm._v("Refining the lens...")])
                      : _c("span", [_vm._v("Thinking...")]),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.error
          ? _c("div", { staticClass: "viq-lens-builder__error" }, [
              _vm._v(_vm._s(_vm.error)),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.currentConfig && !_vm.loading
      ? _c("div", { staticClass: "viq-lens-builder__confirm" }, [
          _c(
            "button",
            {
              staticClass: "viq-lens-builder__confirm-btn",
              attrs: { disabled: _vm.confirming },
              on: { click: _vm.confirmLens },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.confirming
                      ? "Saving..."
                      : `Create "${_vm.currentConfig.name}"`
                  ) +
                  "\n    "
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "viq-lens-builder__input-area" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.input,
            expression: "input",
          },
        ],
        ref: "lensInput",
        attrs: {
          type: "text",
          placeholder: _vm.inputPlaceholder,
          disabled: _vm.loading || _vm.confirming,
        },
        domProps: { value: _vm.input },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.handleSend.apply(null, arguments)
          },
          input: function ($event) {
            if ($event.target.composing) return
            _vm.input = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "viq-lens-builder__send",
          attrs: {
            disabled: _vm.loading || _vm.confirming || !_vm.input.trim(),
          },
          on: { click: _vm.handleSend },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
              },
            },
            [
              _c("path", {
                attrs: {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8",
                },
              }),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }